import { gossipFeed } from '@/mocks/home';

export default function GossipFeed() {
  return (
    <section id="feed" className="w-full">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] text-secondary-700">
              <i className="ri-camera-lens-line text-sm"></i>
              ON SITE
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              吃瓜帖围观现场
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              图文并重的围观记录，标题概括重点，短摘要补一句现场感，点进去就是完整的讨论过程。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {['全部', '综艺', '品牌', '路透'].map((tab, idx) => (
              <button
                key={tab}
                type="button"
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-xs font-semibold transition-colors ${
                  idx === 0
                    ? 'bg-foreground-950 text-background-50'
                    : 'border text-foreground-600 hover:bg-background-100 hairline'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {gossipFeed.map((item) => (
            <article
              key={item.id}
              className="card-lift group flex cursor-pointer flex-col overflow-hidden rounded-lg border bg-background-50 hairline"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 爱黑料网吃瓜帖`}
                  title={`${item.title} - 围观现场`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-bold text-foreground-900">
                  {item.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950 line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-500 line-clamp-2 md:text-[13px]">
                  {item.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t pt-3 text-xs text-foreground-500 hairline">
                  <span className="flex items-center gap-1.5 font-semibold text-primary-600">
                    <i className="ri-fire-line text-sm"></i>
                    {item.stats}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            className="cursor-pointer whitespace-nowrap rounded-md border px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100 hairline"
          >
            加载更多围观贴
            <i className="ri-arrow-down-line ml-1.5 text-base align-middle"></i>
          </button>
        </div>
      </div>
    </section>
  );
}